import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  CheckAvailabilityRequestBody,
  CheckAvailabilityResponse,
} from '../types/purchases-check-availability'

const NEXT_PROXY_CONFIG = {
  baseURL: '/web/api',
}

const REACT_QUERY_CONFIG = {
  // throwing so that @tanstack/react-query can properly capture errors
  throwError: true,
}

const CLIENT_CONFIG = { ...NEXT_PROXY_CONFIG, ...REACT_QUERY_CONFIG }

export const purchasesCheckAvailability = {
  post: (data: CheckAvailabilityRequestBody) =>
    api.post<CheckAvailabilityResponse>(
      '/checkout/purchases/check_availability',
      data,
      CLIENT_CONFIG,
    ),
  queryKey: 'purchases-check-availability',
}
